import { HTTPClient } from "./Client";

const CriterioApi = {
    async ListarCriteriosAsync() {
        const response = await HTTPClient.get(`/Criterio/ListarCriterios`);
        return response.data;
    },

    async ListarCriteriosTodosAsync() {
        const response = await HTTPClient.get(`/Criterio/ListarCriteriosComPontos`);
        return response.data;
    },
}

export default CriterioApi;